const scripting: any = {
  scripts: 'scripting:scripts',
  execute: 'scripting:execute',
};

export default scripting